import { createAsyncThunk } from '@reduxjs/toolkit';

import { asyncPayloadCreator } from 'utils';

import { AccountService } from 'api';

import { RecoverPasswordProps } from 'models/api';

export const recoveryPassword = createAsyncThunk(
	'forgotPassword/recoverPassword',
	(credentials: RecoverPasswordProps, { rejectWithValue }) =>
		asyncPayloadCreator(credentials, { rejectWithValue }, AccountService.recoveryPassword),
);
